import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    Setting,
    TibboDataType,
    SettingType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Tibbit40Node from '@appblocks/codegeneration/Nodes/Tibbit40Node';

export default class Tibbit40_1Node extends Tibbit40Node {
    constructor() {
        super();
        this.name = 'Tibbit 40_1';
        this.id = 'node_tibbit_40_1';
        this.linkedFeature = 'tibbit_40_1';
        this.description = 'Digital potentiometer, 5KOhm';
        this.range = 5000;

        const settings: Setting[] = [
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tibbit_40_1',
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
